import React, { useEffect, useContext, useState } from "react";
import AppContext from "../contexts/AppContext";
import Header from "../components/header";
import AddRedmineForm from "../components/organisms/add_redmine_form";
import DeleteUserAccount from "../components/delete_user_account";
import ConfigList from "../components/config_list";
import IssueList from "../components/issue_list";
import { setRedmine, setPageTitle } from "../actions";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import componentStyles from "../assets/styles/containers/home";

import { useTranslation } from "react-i18next";
import { useDueDateIssues } from "../hooks/useDueDateIssues";
import { useUsers } from "../hooks/useUsers";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </Box>
  );
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

const useStyles = makeStyles(componentStyles);

const Home = () => {
  const { state, dispatch } = useContext(AppContext);
  const [configList, setConfigList] = useState([]);
  const [tabNum, setTabNum] = React.useState(0);
  const dueDateTerm = 7;
  const classes = useStyles();
  const { t } = useTranslation();

  const { allDueDateissues, getAllDueDateIssues, errors, loading } =
    useDueDateIssues();
  const { getUser } = useUsers();

  useEffect(() => {
    async function getCurrentAuthenticatedUser() {
      setPageTitle(dispatch, t("label_home"));
    }
    getCurrentAuthenticatedUser();
  }, []);

  useEffect(() => {
    if (state.siteConfigs.length === 1) {
      setRedmine(dispatch, state.siteConfigs[0]);
    }
    getAllDueDateIssues();
  }, [state.siteConfigs]);

  useEffect(() => {
    if (allDueDateissues?.length) {
      let users = [];
      allDueDateissues.forEach((issue) => {
        [issue.author, issue.assigned_to].forEach((u) => {
          if (
            u &&
            !users.some(
              (user) =>
                user?.id === u.id && user?.redmine_id === issue.redmine_id
            )
          ) {
            u.redmine_id = issue.redmine_id;
            users.push(u);
          }
        });
      });
      users.forEach((user) => {
        if (
          !state.users?.some(
            (existUser) =>
              existUser.id === user.id &&
              existUser.redmine_id === user.redmine_id
          )
        ) {
          const config = state.siteConfigs.find(
            (config) => config.id === user.redmine_id
          );
          getUser({
            id: user.id,
            apikey: config.apikey,
            redmineurl: config.redmineurl,
          });
        }
      });
    }
  }, [allDueDateissues, state.current]);

  const handleClickSetConfig = (config) => setRedmine(dispatch, config);

  const handleChangeTab = (event, tabNum) => setTabNum(tabNum);

  const unSetMessage = t("home.text_add_redmine");

  return (
    <>
      <Header />

      <Container
        maxWidth={false}
        component={Box}
        marginTop="-6rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container justify="center">
          <Grid item xs={12} component={Box} marginBottom="3rem!important">
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                classes={{ root: classes.cardHeaderRoot }}
                subheader={
                  <Grid
                    container
                    component={Box}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Grid item xs="auto">
                      <Box
                        component={Typography}
                        variant="h3"
                        marginBottom="0!important"
                      >
                        {t("home.label_redmine_list")}
                      </Box>
                    </Grid>
                    <Grid item xs="auto">
                      <Box
                        justifyContent="flex-end"
                        display="flex"
                        flexWrap="wrap"
                      >
                        <AddRedmineForm />
                      </Box>
                    </Grid>
                  </Grid>
                }
              ></CardHeader>
              {configList ? (
                <ConfigList handleClickSetConfig={handleClickSetConfig} />
              ) : (
                unSetMessage
              )}
            </Card>
          </Grid>

          <Grid item xs={12} component={Box} marginBottom="3rem!important">
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                subheader={
                  <Grid
                    container
                    component={Box}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Grid item xs="auto">
                      <Box
                        component={Typography}
                        variant="h3"
                        marginBottom="0!important"
                      >
                        {t("home.label_due_date_issues", { term: dueDateTerm })}
                      </Box>
                    </Grid>
                  </Grid>
                }
              ></CardHeader>
              <CardContent>
                {state.siteConfigs.length > 0 ? (
                  loading ? (
                    <Box classes={{ root: classes.circularProgressContainer }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      {errors.internal ? (
                        <Box marginBottom="1rem">
                          <Alert severity="error">{`${errors.internal}`}</Alert>
                        </Box>
                      ) : null}
                      {errors.network && errors.network.length > 0
                        ? errors.network.map((error, index) => {
                            return (
                              <Box marginBottom="1rem">
                                <Alert key={index} severity="error">
                                  {`${error.redmineUrl} を読み込めませんでした - ${error.message}`}
                                </Alert>
                              </Box>
                            );
                          })
                        : null}
                      <Tabs
                        value={tabNum}
                        onChange={handleChangeTab}
                        variant="scrollable"
                        aria-label="due date issues"
                      >
                        <Tab label={state.current.name} {...a11yProps(0)} />
                        <Tab label={t("label_all")} {...a11yProps(1)} />
                      </Tabs>
                      <TabPanel value={tabNum} index={0}>
                        {
                          <IssueList
                            issues={allDueDateissues.filter(
                              (issue) => issue.redmine_id === state.current.id
                            )}
                          />
                        }
                      </TabPanel>
                      <TabPanel value={tabNum} index={1}>
                        {<IssueList issues={allDueDateissues} />}
                      </TabPanel>
                    </>
                  )
                ) : null}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} component={Box}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                classes={{ root: classes.cardHeaderRoot }}
                subheader={
                  <Grid
                    container
                    component={Box}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Grid item xs="auto">
                      <Box
                        component={Typography}
                        variant="h3"
                        marginBottom="0!important"
                      >
                        {t("home.delete_user_account.label_delete_user")}
                      </Box>
                    </Grid>
                  </Grid>
                }
              ></CardHeader>
              <DeleteUserAccount />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Home;
